function initTestimonialsSlider(sectionId, speed = 5000) {
  const sliderLgHide = new Swiper(
    `.collection-testimonials__slider--${sectionId}.lg-hide .swiper`,
    {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      resistanceRatio: 0,
      speed: speed,
      allowTouchMove: false,
      disableOnInteraction: true,
      autoplay: {
        delay: 0.1,
      },
    },
  );

  const sliderLgShow = new Swiper(
    `.collection-testimonials__slider--${sectionId}.lg-show .swiper`,
    {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 10,
      pagination: {
        el: `.swiper-pagination--${sectionId}`,
        type: 'fraction',
      },
      navigation: {
        nextEl: `.swiper-button-next--${sectionId}`,
        prevEl: `.swiper-button-prev--${sectionId}`,
      },
    },
  );

  return {sliderLgHide, sliderLgShow};
}
